export default __webpack_public_path__ + "static/media/Country in Colusa.12d751c4.png";